import React from 'react'
import Abouts from '../components/Abouts';

function About() {
  return (
    <div className="mt-5">
      <Abouts/>

    </div>
  )
}

export default About;